import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import './Chat.css';
import axios from "axios";
import Avatar from '../Avatar/Avatar';
import { AppContext } from '../Context/AppContext';

function Chats() {

  // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
 // axios.defaults.withCredentials = true;

  const inpRef = useRef();

  const [questionAns, setQuestionAns] = useState([]);

  const [isConservation, setIsConservation] = useState(false);

  const YOU = "You";
  const AI = "AI";

  const [loading, setLoading] = useState(false);
  const [shouldScroll, setShouldScroll] = useState(true);
  const [headerFor, setHeaderFor] = useState('');
  const [chatTitle, setChatTitle] = useState('');
  const chatBoxTextField = document.getElementById('chatbox-message-field');
  const [answer, setAnswer] = useState("Hi");
  const [showAvatarPopup, setShowAvatarPopup] = useState(false);
  const avatarRef = useRef(null);
  const { handleSpeak } = useContext(AppContext);
  const [language, setLanguage] = useState("en");
  const [firstMsg, setFirstMsg] = useState("Hi,");

  let __for;

  const handleOnKeyUp = () => {
    var maxHeight = getComputedStyle(chatBoxTextField).getPropertyValue('--chatbox-max-height')
    chatBoxTextField.removeAttribute('style')
    setTimeout(() => {
      if (chatBoxTextField.scrollHeight > maxHeight) {
        chatBoxTextField.style.height = `${maxHeight}px`
      } else {
        chatBoxTextField.style.height = `${chatBoxTextField.scrollHeight}px`
      }
    }, 0)
  }

  const updateAns = (from, value, isPromt = 0) => {

    if (from === 'AI') {
      setAnswer(value);
      if (!isPromt) {
        try {
          const message = { 'text': "" };
          // console.log("1. Sent Message from the chatbot to the parent: ", message); 
          window.parent.postMessage(message, "*");
        } catch (err) {

        }
      }
      // console.log("Sending Language:", selectedLanguage);      
    } else if (from === 'AI_Options') {
      setAnswer(value);
    }

    setQuestionAns((questionAns) => [...questionAns, { from: from, value: value }])

    setShouldScroll(true);
  }

  const renderAnswer = (ans) => {
    const value = ans.value;
    const valArr = value.split('\n')
    var tableArr = []

    valArr.map(item => {
      var element = item.trim().split("|").map(row => row.trim()).filter(row => row !== "")
      element = element.filter(row => !row.includes("---------------------")).map(row => row.trim());
      if (element.length > 0) {
        tableArr.push(element)
      }
      return false;
    })

    if (tableArr[0].length === 2) {
      return <>
        <table>{
          tableArr.map((row, index) => {
            return (
              <tr key={'tr_' + index}>
                <td style={{ border: "1px solid" }}>{row[0]}</td>
                <td style={{ border: "1px solid" }}>{row[1]}</td>
              </tr>
            )
          })
        }
        </table>
      </>
    } else {
      return <>
        {
          tableArr.map((row, i) => {
            return (
              <Fragment key={'fr_' + i}>
                {row[0]}<br></br>
              </Fragment>
            )
          })
        }
      </>
    }

  };

  function getServerUrl(path) {
    return `${window.location.protocol}//${window.location.hostname}:${443}${path}`;
  }

  const handleSend = (userInput) => {

    if (userInput.trim() !== '') {
      updateAns(YOU, userInput);
      setLoading(true);
      const chatUrl = getServerUrl('/chat');
      let selectedLanguage = localStorage.getItem("selectedLanguage") || language;

      //  console.log("Sending Language:", selectedLanguage);
      try {
        const message = { 'text': userInput };
        // console.log("1. Sent Message from the chatbot to the parent: ", message)
        window.parent.postMessage(message, "*");
      } catch (err) {

      }

      axios.post(chatUrl, {
        userInput,
        language: selectedLanguage,
        location: window.location
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }).then((res) => {
        updateAns(AI, res.data.answer);
        handleSpeak(res.data.answer);
      }).catch((error) => {
        console.error("Chat API Error:", error);
      }).finally(() => {
        setLoading(false);
      });

      inpRef.current.value = "";
    }
  };


  function getWindowLocation() {
    try {
      const location = window.location;
      if (location) {
        let _for = location.search ? location.search.split('?')[1] : ''
        __for = _for.split('/')[0];
        setHeaderFor(__for);
        if (__for === "") {
          import(`../FSC.css`);
        } else {
          if (__for.toLowerCase().includes("merck")) {
            setFirstMsg("Hi, I'm Dr. Smith!");
            import(`../MerckOmnichannel.css`);
            return;
          }
          import(`../${__for}.css`)
            .then(() => {
              if (__for === 'Conservation') {
                setFirstMsg("Hi, I'm Wayne!");
                setIsConservation(true);
              }

            })
            .catch((err) => {
              console.error(`Error loading CSS for ${__for}:`, err);
            });
        }
        if (__for === "NASBA") {
          setChatTitle("NASBA Refreshopedia")
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  function addEventOnChat() {

    try {

      let prompt_4 = {
        "title": "Light Nudge with Capability, Alignment & Validation Prompts",
        "set_1": [
          {
            "title": "Capability: Assess what the vendor can do technically.",
            "oTxt": {
              "label": "What specific AI capabilities does Quantum AI provide?"
            }
          },
          {
            "oTxt": {
              "label": "What solution does NeuralTech Innovations offer?"
            }
          },
          {
            "oTxt": {
              "label": "What AI solution is Insight Analytics offering?"
            }
          }
        ],
        "set_2": [
          {
            "title": "Alignment: Check whether the vendor's approach fits Atlas Global's strategy.",
            "oTxt": {
              "label": "Does Quantum AI's solution align with Atlas Global's business goals?"
            }
          },
          {
            "oTxt": {
              "label": "Does NeuralTech's solution align with Atlas Global's AI goals?"
            }
          },
          {
            "oTxt": {
              "label": "Does Insight Analytics address Atlas Global's AI goals?"
            }
          }
        ],
        "set_3": [
          {
            "title": "Validation: Verify if vendor claims are backed by evidence.",
            "oTxt": {
              "label": "Have Quantum AI's claims been tested in real-world environments?"
            }
          },
          {
            "oTxt": {
              "label": "Has NeuralTech proven its platform in real-world deployments?"
            }
          },
          {
            "oTxt": {
              "label": "Is there real-world evidence of Insight Analytics' success?"
            }
          }
        ],
      }

      let prompt_5 = {
        "title": "Deeper Probing with Evidence, Adaptability & Total Cost",
        "set_1": [
          {
            "title": "Evidence: Ask for detailed proof of performance.",
            "oTxt": {
              "label": "Can you share customer success stories related to your platform?"
            }
          },
          {
            "oTxt": {
              "label": "Are there independent reviews or third-party validations?"
            }
          },
          {
            "oTxt": {
              "label": "How have your tools performed in industries similar to ours?"
            }
          }
        ],
        "set_2": [
          {
            "title": "Adaptability: Test flexibility and fit with existing systems.",
            "oTxt": {
              "label": "How customizable is your platform for specific business needs?"
            }
          },
          {
            "oTxt": {
              "label": "Can your solution scale across multiple departments?"
            }
          },
          {
            "oTxt": {
              "label": "How does your platform integrate with our existing tech stack?"
            }
          }
        ],
        "set_3": [
          {
            "title": "Total Cost: Uncover the full financial picture.",
            "oTxt": {
              "label": "What is the total cost of ownership over 3 years?"
            }
          },
          {
            "oTxt": {
              "label": "Are there hidden costs for support, upgrades, or integration?"
            }
          },
          {
            "oTxt": {
              "label": "How do your pricing tiers compare to competitors?"
            }
          }
        ]
      }

      let AI_Univ_Prompt = {
        "prompt_1": {
          "qTxt": "Hello! We noticed you have been inactive for a bit; do you need any help? Type a question in the message box."
        },
        "prompt_2": {
          "qTxt": "Hello! We noticed you aren't interacting with the chatbot; do you need help? Select an option:",
          "options": [{
            "oTxt": {
              "label": "Yes"
            },
            "qTxt": "Would you like to know where to begin? You can start by asking questions about your task."
          },
          {
            "oTxt": {
              "label": "No"
            },
          }]
        },
        "prompt_3": {
          "qTxt": "Hello! We noticed you aren't interacting with the chatbot; do you need help?",
          "options": [{
            "oTxt": {
              "label": "Yes"
            },
            "qTxt": "Would you like to know where to begin? Refer to the supporting documents in the Resources section for guidance."
          },
          {
            "oTxt": {
              "label": "No"
            },
          }]
        },
        "prompt_4": {
          "qTxt": "Hello! You've been exploring for a bit — how's it going so far?"
        },
        "prompt_5": {
          "qTxt": "You've been reflecting for a while. Ready to test your thinking or explore what might happen next?"
        },
        /*"prompt_4": {
          "qTxt": "Hello! We noticed you aren't interacting with the chatbot; do you need help? Let me help with some questions you can begin with.",
          "options": prompt_4["set_1"]
        },
        "prompt_5": {
          "qTxt": "Hello! We noticed you aren't interacting with the chatbot; do you need help? Let me help with some questions you can begin with.",
          "options": prompt_5["set_1"]
        }*/
      }

      window.addEventListener('message', (event) => {
        // console.log("Recived: message_for_chatbot:  ", event.data);
        // let _prompt = "prompt_1: Hello! We noticed you have been inactive for a bit; do you need any help? Type a question in the message box.";

        let _prompt = AI_Univ_Prompt[event.data.pId] || "";
 
      /*  let _setNo = event.data.setNo || 1;
        if (event.data.pId === 'prompt_4') {
          _prompt["options"] = prompt_4["set_" + _setNo]
        } else if (event.data.pId === 'prompt_5') {
          _prompt["options"] = prompt_5["set_" + _setNo]
        }
      */
        // console.log("_prompt: ", _prompt);
        // handleSend(_prompt)

        if (_prompt && (_prompt !== "")) {
          updateAns(AI, _prompt['qTxt'], 1);

          let options = _prompt["options"] || "";
          if (options) {
            updateAns("AI_Options", options, 0);
          }
        }

      });
    } catch (err) {

    }


    const chatBox = document.getElementById('chatbox-message-field');

    chatBox.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        const Inp = inpRef.current.value
        handleSend(Inp)
      }
    });

    getWindowLocation();

    updateAns("AI", `${firstMsg} How can I help ? `)

  }

  const handleSpeakCallback = (text) => {
    // Trigger the handleSpeak function in Avatar via the ref
    if (avatarRef.current) {
      avatarRef.current.handleSpeak(text);
    }
  };

  useEffect(() => {
    addEventOnChat()
    if (window.location.search.includes('avatar') || window.location.pathname.includes('avatar')) {
      setShowAvatarPopup(true);
    }
  }, []);

  useEffect(() => {
    if (shouldScroll) {
      const chatArea = document.querySelector('.chatbox-body');
      if (chatArea) {
        chatArea.scrollTo({
          top: chatArea.scrollHeight,
          behavior: 'smooth'
        });
      }
      setShouldScroll(false);
    }
  }, [shouldScroll]);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      setLanguage(savedLanguage);
    }

    const handleMessage = (event) => {
      if (event.data?.type === "languageChange") {
        setLanguage(event.data.language);
        localStorage.setItem("selectedLanguage", event.data.language);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  let optionHandleClick = function (data) {
    let qTxt = data.qTxt || "";
    if (qTxt !== "") {
      updateAns(AI, qTxt, 1);
      try {
        const message = { 'text': qTxt };
        window.parent.postMessage(message, "*");
      } catch (err) {
      }
      return;
    }
    let label = data.oTxt.label;
    console.log('You clicked: ', label);
    handleSend(label);
  }


  return (
    <>
      <div id={headerFor.toLowerCase().includes("merck") ? "MerckOmnichannel" : headerFor} className="content-md-lg py-3 chatbot-main">
        <div className="col-lg-8 col-md-10 col-sm-12 col-12 mx-auto">
        </div>
        <div id="chatbox-wrapper">
          {showAvatarPopup && (<Avatar answer={{ answer }} showAvatarPopup={showAvatarPopup} onSpeakCallback={handleSpeakCallback} ref={avatarRef} isConservation={isConservation} />)}
          <div id="chatbox" className='show'>
            <div className="chatbox-dialog box2" style={{ opacity: "1" }} id="box2">
              <div className="chatbox-header text-center">
                {
                  (headerFor.toLowerCase().includes("merck") ? true : false) && <>
                    <img src='/assets/images/dr-smith.png' alt="doctor-smith" class="dr-image" />
                    <div class="chat-logo"></div>
                  </>}
                <div className="chat-title">{chatTitle}</div>
                {/* <div className="chat-icon" id='chat-icon'></div> */}
              </div>
              <div className="chatbox-body">
                {
                  questionAns.map((qna, index) => {
                    if (qna.from === "You") {
                      return (
                        <div className="chatbox-item chatbox-msg-receiver" key={"you_" + index}>
                          <div className="chatbox-item-content-wrapper">
                            <span className="chatbox-item-content">{renderAnswer(qna)}</span>
                          </div>
                        </div>)
                    }
                    if (qna.from === "AI") {
                      return (
                        <div className="chatbox-item chatbox-msg-sender" key={"ai_" + index}>
                          <div className="chatbox-item-content-wrapper">
                            <span className="chatbox-item-content">{renderAnswer(qna)}</span>
                          </div>
                        </div>
                      )
                    }
                    if (qna.from === "AI_Options") {
                      return (
                        <div className="chatbox-item chatbox-msg-sender" key={"ai_" + index}>
                          <div className="chatbox-item-content-wrapper">
                            <div className="chatbox-options"> {
                              qna.value && qna.value.map((option, oi) => {
                                return (
                                  <button className="option-btn" onClick={() => optionHandleClick(option)} key={"ai_" + index + "_option_" + oi}>{option.oTxt.label}
                                    <img src='/assets/images/arrow.png' alt="" class="arrow-image" />
                                  </button>
                                )
                              })
                            }
                            </div>
                          </div>
                        </div>
                      )
                    }
                  })
                }
                {loading && (
                  <div className="chatbox-item chatbox-msg-sender ">

                    <div className="chatbox-item-content-wrapper">
                      <span className="chatbox-item-content">
                        <div id='loader'>
                          <div className='dot-flashing'></div>
                        </div>
                      </span>
                    </div>
                  </div>
                )}
              </div>
              <div className="chatbox-footer">
                <div className="chatbox-footerInner">
                  <div className="chatbox-field-wrapper">
                    <input type='text' name="message" id="chatbox-message-field"
                      placeholder={headerFor === 'Conservation' ? "Type your question and click the arrow." : "Ask me anything"} ref={inpRef} onKeyUp={handleOnKeyUp} ></input>
                  </div>
                  <div className="chatboxBwrapper">
                    <button id="sendBtn" className="sendBtn" onClick={() => handleSend(inpRef.current.value)} ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>

  )
}

export default Chats